import { render, staticRenderFns } from "./Deviz_produse_dialog.vue?vue&type=template&id=71941214&scoped=true&"
import script from "./Deviz_produse_dialog.vue?vue&type=script&lang=js&"
export * from "./Deviz_produse_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Deviz_produse_dialog.vue?vue&type=style&index=0&id=71941214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71941214",
  null
  
)

export default component.exports